// Calculate Days to Deadline
export const calculateDaysToDeadline = (reviewDeadline: Date) => {
  const today = new Date();
  const timeDifference = reviewDeadline.getTime() - today.getTime();
  return Math.floor(timeDifference / (1000 * 60 * 60 * 24));
};

// Calculate Days Overdue
const calculateDaysOverdue = (deadline: Date, today: Date): number => {
  const msPerDay = 1000 * 60 * 60 * 24;
  const timeDifference = today.getTime() - deadline.getTime();
  return Math.floor(timeDifference / msPerDay);
};

export const MAX_DAYS_TO_EXPIRE_DEADLINE = 5;

export const checkOverdueDeadlineMessage = (
  currentDeadline: Date | null,
  status: string
) => {
  const todaysDate = new Date();

  const deadlineDate = currentDeadline ? new Date(currentDeadline) : null;

  if (!deadlineDate) {
    return {
      todaysDate,
      deadlineMessage: '',
      daysToDeadline: 0
    };
  }

  const daysToDeadline = calculateDaysToDeadline(deadlineDate);
  const isOverdue = todaysDate > deadlineDate;
  const daysOverdue = isOverdue
    ? calculateDaysOverdue(deadlineDate, todaysDate)
    : 0;

  let deadlineMessage = '';

  if (status === 'invited') {
    deadlineMessage = isOverdue
      ? `${daysOverdue} days overdue to accept invitation`
      : daysToDeadline === 0
      ? 'Deadline expires today to accept invitation'
      : `${daysToDeadline} days to accept invitation`;
  } else if (status === 'assessment') {
    deadlineMessage = isOverdue
      ? `${daysOverdue} days overdue to submit their Review`
      : daysToDeadline === 0
      ? 'Deadline expires today to submit their Review'
      : `${daysToDeadline} days to submit their Review`;
  }

  return {
    todaysDate,
    deadlineMessage,
    daysToDeadline
  };
};
